module.exports = __webpack_public_path__ + "c94c65cd101fcb28eaae7723035b0960.pdf";